// API Configuration for Dana's Food Detective
export const API_CONFIG = {
  SPOONACULAR: {
    enabled: true,
    apiKey: "5e6e51902da842e399d65d39bbfa49d3",
    baseUrl: "https://api.spoonacular.com",
    maxResults: 100,
    rateLimit: 10000,
  },
  SPOONACULAR_IMAGE: {
    enabled: true,
    apiKey: "5e6e51902da842e399d65d39bbfa49d3",
    baseUrl: "https://api.spoonacular.com",
  },
  FOOD_DATA_CENTRAL: {
    enabled: true,
    apiKey: "DEMO_KEY", // Free tier available
    baseUrl: "https://api.nal.usda.gov/fdc/v1",
  },
  OPEN_FOOD_FACTS: {
    enabled: true,
    baseUrl: "https://world.openfoodfacts.org/api/v0/product",
  },
  GOOGLE_VISION: {
    enabled: false, // Set to true when you get an API key
    apiKey: "", // Add your Google Vision API key here
    baseUrl: "https://vision.googleapis.com/v1/images:annotate",
  },
  CLARIFAI: {
    enabled: false,
    apiKey: "",
    baseUrl: "https://api.clarifai.com/v2/models/food-item-recognition/outputs",
  },
  AZURE_VISION: {
    enabled: false,
    apiKey: "",
    baseUrl:
      "https://your-resource.cognitiveservices.azure.com/vision/v3.2/analyze",
  },
  RECIPE_PUPPY: {
    enabled: false,
    baseUrl: "http://www.recipepuppy.com/api",
  },
};

// Alpha-Gal Safe Recipes Database
export const ALPHA_GAL_RECIPES = [
  {
    id: "ag-chicken-1",
    title: "Grilled Lemon Herb Chicken",
    time: "⏰ 30 minutes",
    servings: "👥 4 servings",
    summary:
      "Tender grilled chicken with fresh herbs and lemon - perfect for Alpha-Gal safe dining",
    image: "https://images.unsplash.com/photo-1604503468506-a8da13d82791?w=400",
    category: "chicken",
    ingredients: ["chicken", "lemon", "herbs", "olive oil"],
    instructions:
      "Marinate chicken with lemon, herbs, and olive oil. Grill for 6-7 minutes per side until cooked through.",
    alphaGalSafe: true,
  },
  {
    id: "ag-chicken-2",
    title: "Lemon Herb Chicken",
    time: "⏰ 25 minutes",
    servings: "👥 4 servings",
    summary: "Bright and flavorful chicken with lemon and herbs",
    image: "https://images.unsplash.com/photo-1604503468506-a8da13d82791?w=400",
    category: "chicken",
    ingredients: ["chicken", "lemon", "herbs"],
    instructions:
      "Season chicken with herbs and lemon. Cook in a pan until golden and cooked through.",
    alphaGalSafe: true,
  },
  {
    id: "ag-fish-1",
    title: "Baked Salmon with Herbs",
    time: "⏰ 20 minutes",
    servings: "👥 2 servings",
    summary: "Simple and delicious baked salmon with fresh herbs",
    image: "https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400",
    category: "fish",
    ingredients: ["salmon", "herbs", "lemon", "olive oil"],
    instructions:
      "Season salmon with herbs, lemon, and olive oil. Bake at 400°F for 12-15 minutes.",
    alphaGalSafe: true,
  },
  {
    id: "ag-vegetarian-1",
    title: "Mediterranean Quinoa Bowl",
    time: "⏰ 15 minutes",
    servings: "👥 2 servings",
    summary: "Nutritious quinoa bowl with Mediterranean vegetables",
    image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400",
    category: "vegetarian",
    ingredients: ["quinoa", "tomatoes", "cucumber", "olives", "feta"],
    instructions:
      "Cook quinoa according to package directions. Mix with chopped vegetables and serve.",
    alphaGalSafe: true,
  },
  {
    id: "ag-vegetarian-2",
    title: "Roasted Vegetable Pasta",
    time: "⏰ 35 minutes",
    servings: "👥 4 servings",
    summary: "Hearty pasta with roasted seasonal vegetables",
    image: "https://images.unsplash.com/photo-1621996346565-e3dbc353d2e5?w=400",
    category: "vegetarian",
    ingredients: ["pasta", "zucchini", "bell peppers", "tomatoes", "olive oil"],
    instructions:
      "Roast vegetables at 425°F for 20 minutes. Cook pasta and combine with roasted vegetables.",
    alphaGalSafe: true,
  },
  {
    id: "ag-vegetarian-3",
    title: "Creamy Mushroom Risotto",
    time: "⏰ 30 minutes",
    servings: "👥 3 servings",
    summary: "Rich and creamy risotto with wild mushrooms",
    image: "https://images.unsplash.com/photo-1476124369491-e7addf5db371?w=400",
    category: "vegetarian",
    ingredients: ["arborio rice", "mushrooms", "vegetable broth", "parmesan"],
    instructions:
      "Sauté mushrooms, add rice and gradually add warm broth while stirring until creamy.",
    alphaGalSafe: true,
  },
];

// Brand-specific product database
export const BRAND_PRODUCTS = {
  oreo: {
    name: "Oreo Cookies",
    isSafe: false,
    reason: "Contains milk and whey - not Alpha-Gal safe",
    confidence: 0.95,
  },
  ritz: {
    name: "Ritz Crackers",
    isSafe: true,
    reason: "No mammalian products detected",
    confidence: 0.9,
  },
  "ritz crackers": {
    name: "Ritz Crackers",
    isSafe: true,
    reason: "No mammalian products detected",
    confidence: 0.9,
  },
};
